<template>
<div>
    <explanation-hiding-description
        :appliedHidings="hidings"
    ></explanation-hiding-description>

</div>
</template>

<script>
import ExplanationHidingDescription from './components/ExplanationHiidngDescription.vue'

export default {
    components: {
        ExplanationHidingDescription,
    },

    computed: {
        hidings() {
            const hidings = this.$store.get('explanation/explanation@tryout_hidings')

            return hidings ? hidings : []
        }
    },
}
</script>
